import React from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';

function InventoryView(props) {
    const columns = [

        { field: 'item', headerName: 'Item', flex: 1 },
        { field: 'quantity', headerName: 'Quantity', flex: 1 },
        { field: 'schedule', headerName: 'Schedule', flex: 1 }
    ];

    const dataRows = [
        { id: 1, item: 'Chicken cheese burger', quantity: "1000", schedule: "Per Day" },
        { id: 2, item: 'Chicken cheese burger', quantity: "500", schedule: "Sat-sunday" },
    ];
    return (
        <div>
            <div>
                <FilterComponents title={"OK"} isItem={17} />
                <CustomDataGrid columns={columns} dataRows={dataRows} />
            </div>
        </div>
    );
}

export default InventoryView;